import type { QuestionKey } from './constants';
import type { AnswerVisibleStates } from './useDiagnosisVisibleState';

const shouldAutoScrollMap: Record<QuestionKey, boolean> = {
  gender: true,
  jobId: true,
  postalCode: true,
  address: true,
  birthday: true,
  annualIncome: true,
  savings: true,
  monthlySavings: true,
  investment: true,
  hasPartner: true,
  partnerBirthday: true,
  partnerAnnualIncome: true,
  hasChild: true,
  countOfChildren: true,
  firstChildBirthDay: true,
  secondChildBirthDay: true,
  thirdChildBirthDay: true,
  fourthChildBirthDay: true,
  fifthChildBirthDay: true,
  firstChildGender: true,
  secondChildGender: true,
  thirdChildGender: true,
  fourthChildGender: true,
  fifthChildGender: true,
  monthlyRentCost: true,
  loanBalance: true,
  monthlyInsurance: true,
  thinksToughTimesBringOpportunity: true,
  thinksWhatDoneIsDone: true,
  isInterestedInNisaOrIdeco: true,
  hasGoalInFuture: true,
  takesThreeOrMoreLessons: true,
  followsTheLatestTrends: true,
  karteTopics: true,
  karteComment: false,
};

const questionElementIDList: Record<QuestionKey, string> = {
  gender: 'question-gender',
  jobId: 'question-job-id',
  postalCode: 'question-postal-code',
  address: 'question-address',
  birthday: 'question-birthday',
  annualIncome: 'question-annual-income',
  savings: 'question-savings',
  monthlySavings: 'question-monthly-savings',
  investment: 'question-investment',
  hasPartner: 'question-has-partner',
  partnerBirthday: 'question-partner-birthday',
  partnerAnnualIncome: 'question-partner-annual-income',
  hasChild: 'question-has-child',
  countOfChildren: 'question-count-of-children',
  firstChildBirthDay: 'question-first-child-birth-day',
  secondChildBirthDay: 'question-second-child-birth-day',
  thirdChildBirthDay: 'question-third-child-birth-day',
  fourthChildBirthDay: 'question-fourth-child-birth-day',
  fifthChildBirthDay: 'question-fifth-child-birth-day',
  firstChildGender: 'question-first-child-gender',
  secondChildGender: 'question-second-child-gender',
  thirdChildGender: 'question-third-child-gender',
  fourthChildGender: 'question-fourth-child-gender',
  fifthChildGender: 'question-fifth-child-gender',
  monthlyRentCost: 'question-monthly-rent-cost',
  loanBalance: 'question-loan-balance',
  monthlyInsurance: 'question-monthly-insurance',
  thinksToughTimesBringOpportunity:
    'question-thinks-tough-times-bring-opportunity',
  thinksWhatDoneIsDone: 'question-thinks-what-done-is-done',
  isInterestedInNisaOrIdeco: 'question-is-interested-in-nisa-or-ideco',
  hasGoalInFuture: 'question-has-goal-in-future',
  takesThreeOrMoreLessons: 'question-takes-three-or-more-lessons',
  followsTheLatestTrends: 'question-follows-the-latest-trends',
  karteTopics: 'question-karte-topics',
  karteComment: 'question-karte-comment',
};

export const useDiagnosisQuestionScroll = (
  visibleStates: ComputedRef<AnswerVisibleStates>
) => {
  watchRecord(visibleStates, async (newValue, oldValue, effectedKeys) => {
    if (effectedKeys.length === 0) return;

    const changedToVisibleQuestions = effectedKeys.filter((effectedKey) => {
      return (
        oldValue[effectedKey] === 'hidden' && newValue[effectedKey] === 'active'
      );
    });
    if (changedToVisibleQuestions.length === 0) {
      return;
    }
    const firstVisibledQuestion = changedToVisibleQuestions[0];
    if (shouldAutoScrollMap[firstVisibledQuestion]) {
      // transitionを待ってスクロールする
      await wait(200);

      window.document
        .getElementById(questionElementIDList[firstVisibledQuestion])
        ?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
    }
  });

  return {
    questionElementIDList,
  };
};
